import { gsap } from 'gsap'
import { module as BaseModule } from 'modujs'

import { DOMAnimations } from '../utils/dom'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        btn: 'toggle',
      },
    }
  }

  init() {
    this.state = false
    this.btn = this.el.querySelector('[data-accordeon="btn"]')
    this.icon = this.btn.querySelector('.o-icon')
    this.content = this.el.querySelector('[data-accordeon="content"]')

    this.content.style.display = 'none'
    this.btn.setAttribute('aria-expanded', false)

    this.tl = gsap.timeline({ paused: true, duration: 0.1, ease: 'expo.out' })
    this.tl.to(
      this.icon,
      {
        rotate: 45,
      },
      '<',
    )
  }

  toggle() {
    if (this.state) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.tl.timeScale(1).play()
    this.state = true
    this.btn.setAttribute('aria-expanded', true)
    DOMAnimations.slideDown(this.content, 500, 'grid')
  }

  close() {
    this.tl.timeScale(2).reverse()
    this.state = false
    this.btn.setAttribute('aria-expanded', false)
    DOMAnimations.slideUp(this.content)
  }

  // init() {
  //   this.state = false
  //   this.btn = this.el.querySelector('[data-accordeon="btn"]')
  //   this.icon = this.btn.querySelector('.o-icon')
  //   this.content = this.el.querySelector('[data-accordeon="content"]')

  //   const height = this.content.offsetHeight
  //   gsap.set(this.content, { height: 0, autoAlpha: 0 })

  //   this.tl = gsap.timeline({ paused: true, duration: 0.1, ease: 'expo.out' })
  //   this.tl.to(this.content, {
  //     height,
  //   })
  //   this.tl.to(
  //     this.icon,
  //     {
  //       rotate: 45,
  //     },
  //     '<',
  //   )
  //   this.tl.to(
  //     this.content,
  //     {
  //       autoAlpha: 1,
  //     },
  //     '<',
  //   )
  // }

  // toggle() {
  //   if (this.state) {
  //     this.close()
  //   } else {
  //     this.open()
  //   }
  // }

  // open() {
  //   this.tl.timeScale(1).play()
  //   this.state = true
  //   this.btn.setAttribute('aria-expanded', true)
  // }

  // close() {
  //   this.tl.timeScale(2).reverse()
  //   this.state = false
  //   this.btn.setAttribute('aria-expanded', false)
  // }
}
